import cs from "@/styles/modules/card.module.scss";
import s from "./CTABanner.module.scss";
import cn from "classnames";
import { orderLink } from "@/const";
import { Button } from "@/components/UI/Buttons/Button";

type CTABannerProps = {
  className?: string;
};

export const CTABanner = ({ className }: CTABannerProps) => (
  <div className={cn(cs.cardCTAHover, s.card, className)}>
    <a href={orderLink} className={s.link} />
    <div className={s.left}>
      <div className={cn(cs.h3)}>Order your perfect paper right now</div>
      <p className={s.text}>Let professional writers deal with your paper, quickly and efficiently.</p>
    </div>
    <Button href={orderLink} className={s.button}>
      Write My Paper
    </Button>
  </div>
);
